import { Inject, Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import * as io from 'socket.io-client';
import { AuthenticationService } from '../authentication/authentication.service';
import { CsSocket } from './cs-socket';
import { SocketIoConfig, WS_CONFIG } from './socket-config';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket: SocketIOClient.Socket | undefined;
  public $socketConnected = new ReplaySubject<void>(1);
  private $socketDisconnected = new ReplaySubject<void>(1);
  private _connected: boolean = false;
  private _connecting: boolean = false;

  constructor(
    @Inject(WS_CONFIG) private config: SocketIoConfig,
    private authentication: AuthenticationService
  ) {}

  public connect(): void {
    if (this._connected || this._connecting) {
      return;
    }
    this._connecting = true;
    const options: SocketIOClient.ConnectOpts = {
      ...this.config.options,
      query: { token: this.authentication.getToken()! }
    };
    this.socket = io(this.config.url, options);
    this.socket.on('connect', () => {
      this._connected = true;
      this.$socketConnected.next();
    });
    this.socket.on('disconnect', () => {
      this.$socketDisconnected.next();
      this.resetState();
    });
  }

  public getCsSocket<T>(event: string): CsSocket<T> {
    if (this._connected && this.socket) {
      const csSocket = new CsSocket<T>(
        event,
        this.socket,
        this.$socketDisconnected
      );
      return csSocket;
    }
    throw new Error('Socket not initialized');
  }

  public disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = undefined;
    }
  }

  private resetState(): void {
    this.$socketConnected.complete();
    this.$socketDisconnected.complete();
    this.$socketConnected = new ReplaySubject(1);
    this.$socketDisconnected = new ReplaySubject(1);
    this._connected = false;
    this._connecting = false;
  }
}
